"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMascotasCercanas = void 0;
var react_1 = require("react");
var api_1 = require("../lib/api");
function useMascotasCercanas(setLoading) {
    var _a = (0, react_1.useState)([]), petsClose = _a[0], setPetsClose = _a[1];
    (0, react_1.useEffect)(function () {
        navigator.geolocation.getCurrentPosition(function (position) {
            var userLocation = {
                lat: position.coords.latitude,
                lng: position.coords.longitude,
            };
            (0, api_1.fetchMascotasCercanas)(userLocation).then(function (pets) {
                setLoading(false);
                pets.hits.forEach(function (hit) {
                    (0, api_1.fetchPetById)(hit.objectID).then(function (pet) {
                        setPetsClose(function (currVal) { return __spreadArray(__spreadArray([], currVal, true), [pet], false); });
                    });
                });
            });
        });
    }, []);
    return petsClose;
}
exports.useMascotasCercanas = useMascotasCercanas;
